// @vendors
import { Checkbox, Form } from "antd";
import { useContext, useEffect } from "react";
import Context from "../../../context/appContext";
import { getKeys, getDependencyValue, fieldsClear } from "../../../utils/utils";
import moment from "moment";

export default function CheckboxField({ info, key, form, current }) {
  const validate = info.validate ? info.validate : {};
  const {
    dataForm: { data, formResponses, hiddenFields, disabledFields },
    activeBackButton,
    setDataForm,
    checked,
    setChecked,
    setActiveBackButton
  } = useContext(Context);

  useEffect(() => {
    if (info.value && info.value !== null && info.value !== "") {
      setChecked(info.value);
      // form.setFieldsValue({ [info.key]: info.value });
      onChange({ target: { checked: info.value } });
    } else {
      const indexField = formResponses.findIndex((x) => x.key === info.key);
      if (indexField == -1) {
        info.value = info.defaultValue;
        formResponses.push(info);
        onChange({ target: { checked: info.defaultValue } });
      } else {
        setChecked(formResponses[indexField].value);
        onChange({ target: { checked: formResponses[indexField].value } });
      }
    }
  }, []);

  useEffect(() => {
    if(activeBackButton) {
      setActiveBackButton(false);
    }
  }, [activeBackButton])

  const onChange = (event) => {
    info.value = event.target.checked;
    if (checked===true&&!event.target.checked && !activeBackButton) {
      fieldsClear.forEach((e) => {
        form.setFieldsValue({ [e]: "" });
      });
    }
    setChecked(event.target.checked);
    const index = formResponses.findIndex((x) => x.key === info.key);
    index != -1 ? formResponses[index].value = event.target.checked : formResponses.push(info);

    const dependencyValue = getDependencyValue(current, info.key, event.target.checked.toString(), []);
    if (dependencyValue && dependencyValue.length > 0) {
      dependencyValue.forEach((item) => {
        const keyLcl = Object.keys(item)[0];
        hiddenFields[keyLcl] = keyLcl === "otrasNacionalidadesContratante" || keyLcl === "residenteFiscalExtranjeroContratante" ? true : item[keyLcl];
      });
      setDataForm({data, formResponses, hiddenFields: hiddenFields, disabledFields});
    }
    onAutocomplete(event);
  };

  const onAutocomplete = (e) => {
    if (info.properties && info.properties.autocomplete === "true") {
      if (e.target.checked) {
        current && current.newItems.forEach((field) => {
          if (field.key !== info.key) {
            const item = formResponses.find((x) => x.key && x.key.includes(field.customDefaultValue));
            if (item) {
              disabledFields[field.key] = true;
              const index = formResponses.findIndex((x) => x.key === field.key);
              const valueField = item.value ? item.value : form.getFieldValue(field.key) ? form.getFieldValue(field.key) : "";
              const value = field.key === "fechaNacimientoContratante" ? moment(valueField).format("DD/MM/YYYY") : valueField;
              field.value = value;
              index != -1 ? formResponses[index].value = value : formResponses.push(field);
              form.setFieldsValue({ [field.key]: value });
            }
          }
        });
      } else if (checked) {
        const keys = getKeys(current);
        keys && [...keys, "internalIdentifierContratante"].forEach((keyFe) => {
          if (keyFe && keyFe !== "tipoDePersonaContratante" && keyFe !== "datosContratanteIgualAsegurado") {
            disabledFields[keyFe] = false;
            const item = form.getFieldValue(keyFe);
            if (item) {
              const index = formResponses.findIndex((e) => e.key === keyFe);
              if (index != -1) {
                formResponses[index].value = item;
                if (keyFe === "fechaNacimientoContratante") {
                  const de = item.split("/");
                  const datess = `${de[2]}-${de[1]}-${de[0]}`;
                  formResponses[index].value = datess;
                }
              }
            }
          }
        });
        setDataForm((dataForm) => ({ ...dataForm, formResponses }));
      }
    }
  };

  return (
    <Form.Item
      name={info.key}
      key={key}
      hidden={hiddenFields[info.key]}
      valuePropName={validate.required ? "checked" : null}
      rules={[{
        validator:
          !(hiddenFields[info.key] || disabledFields[info.key] || info.disabled) && validate.required ? 
            (_, value) => value ? Promise.resolve() : Promise.reject(new Error("Should accept agreement")) : null,
        required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
        message: "Campo obligatorio",
      }]}
    >
      <Checkbox
        className="c-dr"
        checked={checked}
        disabled={disabledFields[info.key]}
        onChange={onChange}
        data-testid={info.key}
      >
        <td
          dangerouslySetInnerHTML={{ __html: info.label ? info.label : "" }}
        />
      </Checkbox>
    </Form.Item>
  );
}
